import { Badge } from "@/components/ui/badge";
import { TextoTruncado } from "@/components/ds";
import { estadoDocumental, type RecursoDocumentosResumen } from "@/lib/recurso-documentos-estado";

/**
 * Columna "Documentos" de los listados de equipos (EPP, vehículos y
 * maquinaria): la fracción de tipos cargados sobre el catálogo del ámbito, más
 * un badge con lo que hay que resolver.
 *
 * Las tres pantallas comparten diseño, así que comparten también esta celda —
 * y con ella el criterio de `estadoDocumental()`, que es el mismo que pliegan
 * las tarjetas de KPI de la cabecera.
 */
export function CeldaDocumentosRecurso({
  resumen,
  tiposTotal,
}: {
  resumen: RecursoDocumentosResumen | undefined;
  tiposTotal: number;
}) {
  const estado = estadoDocumental(resumen, tiposTotal);

  if (!estado) return <span className="text-soft text-xs">—</span>;

  return (
    // `pr-2` porque la grilla de DataTable no tiene gap entre columnas: sin
    // ese respiro el texto recortado queda pegado a la columna siguiente.
    <div className="flex min-w-0 items-center gap-2 pr-2">
      {/* El contador va verde sólo cuando el catálogo está completo; el badge de
          al lado informa el vencimiento. Separarlos deja leer las dos cosas de
          un vistazo: cuánto falta subir, y qué tan sano está lo ya subido. */}
      <span
        className={`fc-num shrink-0 text-xs font-medium ${
          estado.faltantes === 0 ? "text-success" : "text-destructive"
        }`}
      >
        {estado.cargados}/{tiposTotal}
      </span>
      {/* `shrink` pisa el `shrink-0` que trae `badgeVariants`: sin eso el badge
          conserva su ancho natural, se desborda de la celda de la grilla y
          queda pegado a la columna Estado — el `truncate` de adentro no puede
          recortar nada porque su padre nunca se comprime. */}
      <Badge variant={estado.tono} className="min-w-0 shrink">
        <TextoTruncado className="block truncate">{estado.nota}</TextoTruncado>
      </Badge>
    </div>
  );
}
